import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { WifiOff } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { getPendingResults, setPendingResults } from '@/lib/offlineStore';

let syncing = false;

export async function syncPendingResults(): Promise<void> {
  if (syncing || !navigator.onLine) return;
  const pending = getPendingResults();
  if (pending.length === 0) return;
  syncing = true;
  const left = [];
  let sent = 0;
  for (const p of pending) {
    const res = await supabase.functions.invoke('submit-result', {
      body: { test_id: p.test_id, answers: p.answers, time_taken_seconds: p.time_taken_seconds },
    });
    if (res.data?.success) sent++;
    else if (!navigator.onLine || (res.error && /fetch|network/i.test(res.error.message))) left.push(p);
    // other server errors (e.g. duplicate) are dropped so the queue never blocks
  }
  setPendingResults(left);
  syncing = false;
  if (sent) toast.success(`${sent} offline test result${sent > 1 ? 's' : ''} submitted`);
}

/** Shows an offline banner and submits queued results when the network returns. */
export function OfflineSync() {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const up = () => { setOnline(true); void syncPendingResults(); };
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    const { data } = supabase.auth.onAuthStateChange((_e, s) => { if (s) void syncPendingResults(); });
    void syncPendingResults();
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
      data.subscription.unsubscribe();
    };
  }, []);

  void online;
  return null;
}
